import Cookies from 'js-cookie';

/**
 * Helper function to get the current user's id
 * @returns string
 */
export function getLoggedInUserId() {
  return Cookies.get('user_id');
}
